import * as yup from 'yup';
import { FlashProductTransition } from '../services/models/flash-discount';

/**
 * ==============================================
 * Flash Products
 * ==============================================
 */
export interface IFlashProductsFilterValues {
  searchTerm: string | null;
  barcode: string | null;
  brandId: number | null;
  categoryId: number | null;
  periodTypeId: string | null | undefined;
}

export const flashProductsFilterValuesInitialValues: IFlashProductsFilterValues = {
  searchTerm: '',
  barcode: null,
  brandId: null,
  categoryId: null,
  periodTypeId: null,
};

export const flashProductsFilterValuesValidationSchema = yup.object().shape({
  searchTerm: yup.string().nullable(),
  barcode: yup.string().nullable(),
  brandId: yup.array().nullable(),
  categoryId: yup.array().nullable(),
  periodTypeId: yup.string().nullable().optional(),
});

/**
 * ==============================================
 * Included Flash Products
 * ==============================================
 */
export interface IIncludedFlashProductsFilterValues {
  transition: FlashProductTransition | null;
  periodTypeId: string | null | undefined;
  searchTerm: string | null;
  barcode: string | null;
  brandId: number | null;
  categoryId: number | null;
}

export const flashProductTransitionOptions: {
  value: FlashProductTransition;
  label: string;
}[] = [
  {
    value: FlashProductTransition.waiting,
    label: 'Başlayacak Flaş Ürünler',
  },
  {
    value: FlashProductTransition.active,
    label: 'Devam Eden Flaş Ürünler',
  },
  {
    value: FlashProductTransition.finished,
    label: 'Tamamlanan Flaş Ürünler',
  },
  {
    value: FlashProductTransition.canceled,
    label: 'İptal Edilenler',
  },
];

export const includedFlashProductsFilterValuesInitialValues: IIncludedFlashProductsFilterValues = {
  transition: FlashProductTransition.active,
  periodTypeId: null,
  searchTerm: '',
  barcode: null,
  brandId: null,
  categoryId: null,
};

export const includedFlashProductsFilterValuesValidationSchema = yup.object().shape({
  transition: yup.string().nullable(),
  searchTerm: yup.string().nullable(),
  barcode: yup.string().nullable(),
  brandId: yup.array().nullable(),
  categoryId: yup.array().nullable(),
  periodTypeId: yup.string().nullable().optional(),
});
